<lvr-heading>
	{{ 'sponsor.persons.title' | transloco: { name: sponsor().name } }}
</lvr-heading>

<lvr-button
	variant="primary"
	[label]="'sponsor.persons.create_tt' | transloco"
	[type]="'button'"
	(clicked)="openNewSponsorPersonDialog()"
	icon="add"
>
</lvr-button>

<lvr-sponsor-persons-list
	[personsPage]="personsPage()"
	(pageRequested)="onPageRequested($event)"
	[sponsorName]="sponsor().name"
>
</lvr-sponsor-persons-list>
